import { handleClearInsuranceFromModal } from '../../actions/InsuranceCardActions';
import { updateBookingState } from '../../actions/SchedulingActions';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import { updateBookingStateRequirement } from '../../utils';
import { createGaActionCreatorWithDetails } from '../../utils/createGaActionCreator';
import { INSURANCE_NOT_TAKEN_WARNING } from '../AppointmentRequirements/constants';
import {
    trackBookOutOfNetworkAnyway,
    trackClickCloseModal,
    trackClickFindDoctorsButton,
} from '../BookingContainer/BookingContainerActions';

export const mapDispatchToProps = {
    trackClickCloseModal: (eventDetails) => {
        return (dispatch, getState) => {
            const state = getState();
            const bookingState = bookingStateSelector(state);
            const updatedBookingState = updateBookingStateRequirement(
                bookingState,
                INSURANCE_NOT_TAKEN_WARNING
            );
            dispatch(updateBookingState(updatedBookingState));
            dispatch(trackClickCloseModal(eventDetails));
        };
    },
    trackClickFindDoctorsButton: (procedureId, eventDetails) => {
        return (dispatch) => {
            dispatch(trackClickFindDoctorsButton(procedureId, eventDetails));
        };
    },
    trackClickContinueBookingButton: (eventDetails) => {
        return (dispatch, getState) => {
            const state = getState();
            const bookingState = bookingStateSelector(state);
            const updatedBookingState = updateBookingStateRequirement(
                bookingState,
                INSURANCE_NOT_TAKEN_WARNING
            );
            dispatch(updateBookingState(updatedBookingState));
            dispatch(trackBookOutOfNetworkAnyway(eventDetails));
        };
    },
    trackClickChangeInsuranceButton: () => {
        return (dispatch) => {
            dispatch(handleClearInsuranceFromModal());
        };
    },
    trackModalOpened: (eventDetails) =>
        createGaActionCreatorWithDetails(
            '@@OON/SAW_IT',
            'Booking - Modal',
            'Out of Network Warning Modal',
            eventDetails
        ),
};
